import Logger from '../fw/logger';

export default class GoogleCastText {

  #rmp;
  #castTextForegroundColor = 'FFFFFF99';
  #castTextBackgroundColor = '00000050';
  #castTextFontScale = 1;
  #castTextFontFamily = 'arial';
  #castTextEdgeType = 'NONE';
  #castTextWindowColor = '00000000';

  constructor(rmp) {
    this.#rmp = rmp;
  }

  setCastTextStyle() {
    if (this.#rmp.googleCastCordova) {
      return null;
    }
    if (!this.#rmp.rmpFccCaptions) {
      Logger.print('google-cast', 'could not get textTrackStyle');
      return null;
    }

    const rmpFccCaptions = this.#rmp.rmpFccCaptions;

    const colorMap = {
      white: 'FFFFFF',
      black: '000000',
      red: 'FF0000',
      green: '008000',
      blue: '0000FF',
      yellow: 'FFFF00',
      magenta: 'FF00FF',
      cyan: '00FFFF'
    };

    // prepare Google Cast FCC settings
    let ccFontColor = rmpFccCaptions.fccFontColor;
    switch (rmpFccCaptions.fccFontColor) {
      case 'white':
      case 'black':
      case 'red':
      case 'green':
      case 'blue':
      case 'yellow':
      case 'magenta':
      case 'cyan':
        ccFontColor = colorMap[rmpFccCaptions.fccFontColor];
        break;
      default:
        ccFontColor = 'FFFFFF';
        break;
    }
    let ccFontOpacity = rmpFccCaptions.fccFontOpacity;
    if (ccFontOpacity >= 1) {
      ccFontOpacity = 0.99;
    }
    this.#castTextForegroundColor = ccFontColor + (ccFontOpacity * 100).toString();

    let ccBackgroundColor = rmpFccCaptions.fccBackgroundColor;
    switch (rmpFccCaptions.fccBackgroundColor) {
      case 'white':
      case 'black':
      case 'red':
      case 'green':
      case 'blue':
      case 'yellow':
      case 'magenta':
      case 'cyan':
        ccBackgroundColor = colorMap[rmpFccCaptions.fccBackgroundColor];
        break;
      default:
        ccBackgroundColor = 'FFFFFF';
        break;
    }
    let ccBackgroundOpacity = rmpFccCaptions.fccBackgroundOpacity;
    if (ccBackgroundOpacity >= 1) {
      ccBackgroundOpacity = 0.99;
    }
    this.#castTextBackgroundColor = ccBackgroundColor + (ccBackgroundOpacity * 100).toString();
    this.#castTextEdgeType = rmpFccCaptions.fccFontEdge.toUpperCase();
    this.#castTextFontFamily = rmpFccCaptions.fccFontFamily;
    this.#castTextFontScale = rmpFccCaptions.fccFontSize;
    let ccWindowColor = rmpFccCaptions.fccWindowColor;
    switch (rmpFccCaptions.fccWindowColor) {
      case 'white':
      case 'black':
      case 'red':
      case 'green':
      case 'blue':
      case 'yellow':
      case 'magenta':
      case 'cyan':
        ccWindowColor = colorMap[rmpFccCaptions.fccWindowColor];
        break;
      default:
        ccWindowColor = 'FFFFFF';
        break;
    }
    let ccWindowOpacity = rmpFccCaptions.fccWindowOpacity;
    if (ccWindowOpacity >= 1) {
      ccWindowOpacity = 0.99;
    }
    this.#castTextWindowColor = ccWindowColor + (ccWindowOpacity * 100).toString();
    let textTrackStyle = new window.chrome.cast.media.TextTrackStyle();
    textTrackStyle.foregroundColor = '#' + this.#castTextForegroundColor;
    textTrackStyle.backgroundColor = '#' + this.#castTextBackgroundColor;
    textTrackStyle.fontScale = this.#castTextFontScale;
    textTrackStyle.fontFamily = this.#castTextFontFamily;
    textTrackStyle.edgeType = this.#castTextEdgeType.replace(/\s+/g, '_');
    if (this.#castTextWindowColor !== '00000000') {
      textTrackStyle.windowType = 'NORMAL';
      textTrackStyle.windowColor = '#' + this.#castTextWindowColor;
    }
    Logger.print('google-cast', 'new textTrackStyle follows:', textTrackStyle);
    return textTrackStyle;
  }

  resetSettings() {
    if (this.#rmp.googleCastCordova) {
      return;
    }
    this.#castTextForegroundColor = 'FFFFFF99';
    this.#castTextBackgroundColor = '00000050';
    this.#castTextFontScale = 1;
    this.#castTextFontFamily = 'arial';
    this.#castTextEdgeType = 'NONE';
    this.#castTextWindowColor = '00000000';
  }

  setCastTextTrack(index) {
    if (this.#rmp.googleCastCordova) {
      return;
    }
    if (this.#rmp.remotePlayer && this.#rmp.remotePlayer.isMediaLoaded &&
      this.#rmp.castMedia &&
      this.#rmp.castMediaTracks &&
      this.#rmp.castMediaTracks.length > 0) {
      const castMedia = window.chrome.cast.media;
      if (index === -1) {
        try {
          const tracksInfoRequest = new castMedia.EditTracksInfoRequest([]);
          this.#rmp.castMedia.editTracksInfo(tracksInfoRequest, () => { return; }, console.warn);
        } catch (warning) {
          console.warn(warning);
        }
        return;
      }
      const textTracks = this.#rmp.castMediaTracks.filter(track => {
        return track.type === 'TEXT';
      });
      if (textTracks[index] && typeof textTracks[index].trackId === 'number') {
        const newTextTrackId = textTracks[index].trackId;
        const textTrackStyle = this.setCastTextStyle();
        Logger.print('google-cast', 'set text track on receiving device with id ' + newTextTrackId);
        let tracksInfoRequest;
        if (textTrackStyle) {
          tracksInfoRequest = new castMedia.EditTracksInfoRequest([newTextTrackId], textTrackStyle);
        } else {
          tracksInfoRequest = new castMedia.EditTracksInfoRequest([newTextTrackId]);
        }
        this.#rmp.castMedia.editTracksInfo(tracksInfoRequest, () => { return; }, console.warn);
      }
    }
  }

}
